import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

import { EscolaridadService } from '../../services/escolaridad/escolaridad.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { CatastrofeService } from 'src/app/services/catastrofe/catastrofe.service';
import { PrestamosService } from 'src/app/services/prestamos/prestamos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AfiliacionService } from '../../services/afiliacion/afiliacion.service';
import { Usuario } from '../../models/usuario/usuario.model';
import { Hijo } from '../../models/hijo/hijo.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { MantenedorUsuariosService } from 'src/app/services/mantenedor-usuarios/mantenedor-usuarios.service';
import { AppComponent } from 'src/app/app.component';
import Swal from 'sweetalert2';
import { ConsultaPostulacionesComponent } from '../consulta-postulaciones/consulta-postulaciones.component';
import { TextosService } from '../../services/textos/textos.service';
declare const Rut: any;
declare const ageCalculator: any;

@Component({
  selector: 'app-catastrofe-jub',
  templateUrl: '../../pages/catastrofe/catastrofe.component.html',
  styleUrls: ['../../pages/catastrofe/catastrofe.component.css']
})

export class CatastrofeJubComponent implements OnInit {

  rol: string = localStorage.getItem("rol")
  nombreUsuario: string = localStorage.getItem("nombreUsuario")
  estado: any
  idEjecutivo = localStorage.getItem("idUsuario")
  regiones: any
  comunas: any
  tipoIngreso: any
  otro: boolean = false
  rutUsuario: any
  totalMaximo: any
  diasDiferencia: any
  tipos: any
  postulantes: any[];
  afiliado: any = { rutAfiliado: '', idAfiliado: '', nombreAfiliado: '', apellidoAfiliado: '' };
  cantidadArchivos: any = 1
  textos: any
  linkTexto: any
  buscador: any =
    {
      rut: '', rut2: '', rutConyuge: '', rutAfiliado: '', idRegion: '', fechaInicio: '', fechaFin: '', itemsPerPage: 5, currentPage: 1, idSolicitud: '',
      estado: ['INGRESADA', 'EN VALIDACION', 'RECHAZADA', 'APROBADA']
    }
  catastrofe: any = {
    rutAfiliado: '', rutConyuge: '', domicilioCatastrofe: '', idCiudad: 0, tipoCatastrofe: 0, idRegion: 0, fechaCatastrofe: '',
    archivo: [], archivoTest: null, archivoTest2: null, archivoTest3: null, archivoTest4: null, archivoTest5: null, archivoTest6: null
  }

  constructor(private router: Router, public catastrofeService: CatastrofeService, private escolaridadService: EscolaridadService,
    public prestamosService: PrestamosService, private productosService: ProductosService, private dialog: MatDialog,  private appComponent: AppComponent,
    private postulacionesService: PostulacionesService, private mantenedorUsuarioService: MantenedorUsuariosService, private afiliacionService: AfiliacionService,
    private textosService: TextosService) {

  }

  ngOnInit(): void { this.loadData() }
  loadData() {
    let vm = this
    this.otro = false
    if(localStorage.getItem("jubilado")!='true' && !localStorage.getItem("rol"))
    {
        this.appComponent.logoutJubilado();
    } 
    if (this.rol == 'ROLE_AFILIADO' || this.rol == 'ROLE_JUBILADO') {
      this.afiliado.nombreAfiliado = this.nombreUsuario;
      this.afiliado.rutAfiliado = this.rutUsuario;
      this.afiliado.idAfiliado = this.idEjecutivo;
    }

    this.mantenedorUsuarioService.traeRegiones().then
      (regiones => { this.regiones = regiones })

    this.catastrofeService.traeTipoCatastrofe().then(
      tipo => this.tipos = tipo
    ).catch(error => console.log(error))

    this.productosService.obtieneProductos().then
      (
        productos => productos[9].parametros.map(parametro => {
          console.log('parametro1:', parametro)
          if (parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_CATASTROFE') {
            vm.diasDiferencia = parametro.valor
          }
        })
      )
      .catch(error => console.log(error))


      this.textosService.obtieneTextos()
      .then(textos => {
        vm.textos = textos; // Asigna el resultado del servicio a `this.textos`
        vm.linkTexto = vm.textos.find(item => item.tipoProducto === "CATASTROFE")?.valor;             
      })
      .catch(error => {
        console.error('Error al obtener los textos:', error);
      });

  }

  traeComunas() {
    let vm = this

    this.comunas = []

    this.mantenedorUsuarioService.traeComunas(this.catastrofe.region).then(comunas => vm.comunas = comunas)
  }

  muetraOtros() {
    let vm = this
    this.otro = false;
    vm.tipoIngreso = 0
    for (let i = 0; i < this.tipos.length; i++) {
      if (this.tipos[i].descripcion == 'OTROS') {
        vm.tipoIngreso = this.tipos[i].id;
      } else {
        vm.tipoIngreso = 0
      }
    }
    if (this.catastrofe.tipoCatastrofe == vm.tipoIngreso) {
      this.otro = true;
    }

  }


  sumaArchivo() {
    if (this.cantidadArchivos <= 5) {

      this.cantidadArchivos = this.cantidadArchivos + 1
    }
  }

  restaArchivo() {
    this.cantidadArchivos = this.cantidadArchivos - 1
    this.catastrofe.archivo.splice(this.cantidadArchivos, 1);
  }

  buscaRegistroCivil(rutABuscar: any, ubicacion: any) {
    if (Rut(rutABuscar)) {
      let rut = rutABuscar.split('.').join('').split('-')[0]
      console.log(rutABuscar)
      this.traePostulantes(rut, ubicacion)
    }
    else {
      console.log(rutABuscar)
      this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger')
    }
  }

  traePostulantes(rut: any, ubicacion: any) {
    if(this.rol != 'ROLE_AFILIADO' && this.rol != 'ROLE_JUBILADO'){  
      this.validarEstado(rut.split('-')[0] )
    }
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let vm = this
    this.prestamosService.traePostulantes(rut).then
      (
        (usuario: Usuario) => {

          if (ubicacion == 3) {
            vm.afiliado.nombreAfiliado = usuario.nombres + ' ' + usuario.apellidoPaterno
            vm.afiliado.rutAfiliado = usuario.rut + "-" + usuario.dv
            vm.afiliado.idAfiliado = usuario.id
          }
          Swal.close();
        }

      ).catch(error => {
        console.log(error)
        if((error.error.message) && (error.error.message="Token expirado")){
          vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
          this.appComponent.logoutJubilado();
        }else{
          vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-danger')
        }
        Swal.close();
      })
  }

  buscarHijo(rutABuscar) {
    let rut = rutABuscar.split('-')[0] + rutABuscar.split('-')[1]
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let vm = this
    if (Rut(rutABuscar)) {

      this.catastrofeService.buscarHijo(rut).then
        (
          (hijo: Hijo) => {

            console.log(hijo)
            vm.catastrofe.nombreConyugue = hijo.nombres
            vm.catastrofe.run = hijo.run


            Swal.close();
          }

        ).catch(error => {
          console.log(error)
          Swal.close();
          vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado en el registro civil. Intente nuevamente.', 'btn-danger')
          vm.catastrofe.nombres = ''
          vm.catastrofe.run = ''
          vm.catastrofe.fechaUnion = ''
        })
    } else {
      Swal.close();
      this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger')
      vm.catastrofe.nombreConyugue = ''
      vm.catastrofe.run = ''
      vm.catastrofe.fechaUnion = ''
    }
  }

  validarEstado(rutAfiliado){
    this.afiliacionService.traeSoloAfiliadoSinEstados(rutAfiliado).then
    ( 
        (response: any) => {
            if(response.estadoAfiliado  && (response.estadoAfiliado.toUpperCase() =='PENDIENTE_AFILIACION'
                || response.estadoAfiliado.toUpperCase() =='DESAFILIADO'
                    || response.estadoAfiliado.toUpperCase() =='RECHAZAR_AFILIACION')){
                        console.log(response.estadoAfiliado)
                this.openAlertDialog('El afiliado se encuentra cerrado o en estado pendiente para solicitar beneficios.', 'btn-danger')
                this.router.navigate(['/index'])                 
            }
        }
    )
    .catch
    (
        error => {
          console.log('error :',error);
          if((error.error.message) && (error.error.message="Token expirado")){
            this.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
            this.appComponent.logoutJubilado();
          }else{
            this.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-danger')
          }
       
        }
    ) 
}


  seleccionaArchivo(event: any, numero: number) {
    if (event.target.files.length > 0) {
      console.log(event.target.files[0].type)

      let vm = this
      let reader = new FileReader()
      this.catastrofe.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
      reader.readAsDataURL(event.target.files[0])

      reader.onload = function () {
        vm.catastrofe.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }


      }
    }
  }


  solicitar(form: NgForm) {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    var vm = this
    Swal.showLoading();
    let usuarioId: any
    let fechaUnionNac = new Date(this.catastrofe.fechaCatastrofe + 'T00:00')
    let fechamaxima = new Date()

    if (!vm.catastrofe.archivo[0]) {
      Swal.close();
      this.openAlertDialog('Es obligatorio adjuntar un certificado', 'btn-dark')
      return false
    }


    if (vm.catastrofe.archivo[0].extension != "application/pdf" && vm.catastrofe.archivo[0].extension != "image/jpeg" &&
      vm.catastrofe.archivo[0].extension != "image/png" && vm.catastrofe.archivo[0].extension != "image/jpg") {
      Swal.close();
      this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      return false
    }

    if (vm.catastrofe.archivo[1] && vm.catastrofe.archivo[1].extension != "application/pdf" && vm.catastrofe.archivo[1].extension != "image/jpeg" &&
      vm.catastrofe.archivo[1].extension != "image/png" && vm.catastrofe.archivo[1].extension != "image/jpg") {
      Swal.close();
      this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      return false
    }

    if (vm.catastrofe.archivo[2] && vm.catastrofe.archivo[2].extension != "application/pdf" && vm.catastrofe.archivo[2].extension != "image/jpeg" &&
      vm.catastrofe.archivo[2].extension != "image/png" && vm.catastrofe.archivo[2].extension != "image/jpg") {
      Swal.close();
      this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      return false
    }

    if (vm.catastrofe.archivo[3] && vm.catastrofe.archivo[3].extension != "application/pdf" && vm.catastrofe.archivo[3].extension != "image/jpeg" &&
      vm.catastrofe.archivo[3].extension != "image/png" && vm.catastrofe.archivo[3].extension != "image/jpg") {
      Swal.close();
      this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      return false
    }

    if (vm.catastrofe.archivo[4] && vm.catastrofe.archivo[4].extension != "application/pdf" && vm.catastrofe.archivo[4].extension != "image/jpeg" &&
      vm.catastrofe.archivo[4].extension != "image/png" && vm.catastrofe.archivo[4].extension != "image/jpg") {
      Swal.close();
      this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      return false
    }

    if (vm.catastrofe.archivo[5] && vm.catastrofe.archivo[5].extension != "application/pdf" && vm.catastrofe.archivo[5].extension != "image/jpeg" &&
      vm.catastrofe.archivo[5].extension != "image/png" && vm.catastrofe.archivo[5].extension != "image/jpg") {
      Swal.close();
      this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      return false
    }


    if (fechaUnionNac > fechamaxima) {
      Swal.close();
      this.openAlertDialog('La fecha de catastrofe no debe super la fecha actual. Favor revisar.', 'btn-dark')
      return false
    }


    usuarioId = this.afiliado.idAfiliado;
    let fechaAdopcion = null;
    if (!this.catastrofe.archivo) {
      Swal.close();
      this.openAlertDialog('Debe cargar el certificado como archivo', 'btn-dark')

      return false
    }

    if (!form.valid) {
      Swal.close();
      this.openAlertDialog('Debe ingresar todos los campos obligatorios', 'btn-dark')

      return false
    }



    let fechaCatIngresada = new Date(this.catastrofe.fechaCatastrofe + 'T00:00')
    let fechaMinima = new Date()
    fechaMinima.setDate(fechaMinima.getDate() - this.diasDiferencia)

    if ((fechaCatIngresada < fechaMinima || fechaCatIngresada > new Date())) {
      this.openAlertDialog('La Fecha de solicitud supera la vigencia de 180 dias o excede la fecha actual. Favor revisar.', 'btn-dark')
      Swal.close();
      return false
    }
   
    if(!vm.catastrofe.tipoCatastrofe || vm.catastrofe.tipoCatastrofe==0){
      this.openAlertDialog('El dato tipo de catastrofe es obligatorio.', 'btn-dark')
      Swal.close();
      return false
    }


    let fechaCatastrofe = this.catastrofe.fechaCatastrofe.split('-')[2] + '-' +
    this.catastrofe.fechaCatastrofe.split('-')[1] + '-' +
    this.catastrofe.fechaCatastrofe.split('-')[0]

    

    this.catastrofeService.ingresarCatastrofe(this.catastrofe, fechaCatastrofe, usuarioId, vm.idEjecutivo).then
      (
        response => {
          console.log(response)
          Swal.close();
          vm.openAlertDialog('Se ha ingresado la solicitud correctamente.', 'btn-success')
          vm.limpiarFormulario();
          vm.catastrofe.archivo.bytes = null, vm.catastrofe.archivo.tipo = null
          form.reset()
          return
        }
      )
      .catch
      (error => {
        if((error.error.message) && (error.error.message="Token expirado")){
          vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
          this.appComponent.logoutJubilado();
        }

        if (error.status == 402) {
          vm.openAlertDialog('Afiliado no cumple con su periodo de carencia.', 'btn-danger')
          Swal.close();
        } else if (error.status == 406) {
          vm.openAlertDialog('El afiliado ya tiene una solicitud para el mismo tipo.', 'btn-danger')
          Swal.close();
        } else if(error.status == 412){
          vm.openAlertDialog('Beneficio con fecha de evento anterior a la fecha de afiliación.', 'btn-danger')
          Swal.close();  
        } else if (error.status == 423) {
          vm.openAlertDialog('El afiliado ya alcanzó el tope de solicitudes de Catastrofe.', 'btn-danger')
          Swal.close();        
        } else if (error.status == 409) {
          vm.openAlertDialog('El afiliado tiene una o más solicitudes de catastrofe en tramite.', 'btn-danger')
          Swal.close();
        } else if (error.status == 417) {
          vm.openAlertDialog('Existe una solicitud de catastrofe para el mismo día.', 'btn-danger')
          Swal.close();
        } else if (error.status == 500) {
          vm.openAlertDialog('El afiliado llegó a su máxima cantidad de catastrofes por año.', 'btn-danger')
          Swal.close();
        } else if (error.status == 403) {
          vm.openAlertDialog('Ya completó tope de catástrofe por anualidad.', 'btn-danger')
          Swal.close();
        } else {
          vm.openAlertDialog('El sistema no ha podido generar su solicitud.', 'btn-danger')
          Swal.close();
        }

      }
      )
  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }

  salir() {
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' } }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) { this.router.navigate(['/index']); }
    });
  }

  limpiarFormulario() {
    var vm = this
    vm.catastrofe.domicilioCatastrofe = ''
    vm.catastrofe.region = 0
    vm.catastrofe.comuna = 0
    vm.catastrofe.tipoCatastrofe = 0
    vm.catastrofe.otroTipoCatastrofe = ''
    vm.catastrofe.fechaCatastrofe = ''
    vm.catastrofe.archivoTest = ''
    vm.catastrofe.archivoTest2 = ''
    vm.catastrofe.archivoTest3 = ''
    vm.catastrofe.archivoTest4 = ''
    vm.catastrofe.archivoTest5 = ''
    vm.catastrofe.archivoTest6 = ''
    vm.afiliado.nombreAfiliado = ''
    vm.afiliado.rutAfiliado = ''
    vm.afiliado.idAfiliado = ''
    vm.buscador.rutAfiliado = ''

  }
}
